import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { registerAccount, resendVerification } from "../../services/authService";
import "../welcome/welcome.scss";

function CreateAccount() {
  const [searchParams] = useSearchParams();
  const fromDeveloper = searchParams.get("from") === "developer";
  const role = fromDeveloper ? "developer" : "playtester";
  const signInPath = fromDeveloper ? "/developer/signin" : "/";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setStatus("");
    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    setLoading(true);
    try {
      const result = await registerAccount({ email, password, role });
      setDone(true);
      setStatus(result.message || "Check your email to verify your account.");
    } catch (err) {
      setError(err.response?.data?.message || "Unable to create account. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setError("");
    setLoading(true);
    try {
      const result = await resendVerification(email);
      setStatus(result.message || "If an unverified account exists for that email, we sent a verification link.");
    } catch (err) {
      setStatus("If an unverified account exists for that email, we sent a verification link.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modern-welcome-container">
      <div className="background-elements">
        <div className="bg-element bg-element-1"></div>
        <div className="bg-element bg-element-2"></div>
        <div className="bg-element bg-element-3"></div>
      </div>
      <div className="main-content">
        <div className="content-wrapper">
          <div className="welcome-card">
            <div className="card-background"></div>
            <div className="card-header">
              <h1 className="card-title">Create an account</h1>
              <p className="card-subtitle">
                {fromDeveloper
                  ? "Sign up with email to access the developer portal."
                  : "Sign up with email if you do not want to use Google."}
              </p>
            </div>
            <div className="card-content">
              {!done && (
                <form onSubmit={handleSubmit} style={{ marginBottom: "1.5rem" }}>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email"
                    disabled={loading}
                    required
                    style={{
                      width: "100%",
                      padding: "0.75rem 1rem",
                      borderRadius: "0.5rem",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                      background: "rgba(255, 255, 255, 0.08)",
                      color: "white",
                      marginBottom: "0.75rem",
                    }}
                  />
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password (min 8 characters)"
                    disabled={loading}
                    required
                    style={{
                      width: "100%",
                      padding: "0.75rem 1rem",
                      borderRadius: "0.5rem",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                      background: "rgba(255, 255, 255, 0.08)",
                      color: "white",
                      marginBottom: "0.75rem",
                    }}
                  />
                  <input
                    type="password"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    placeholder="Confirm password"
                    disabled={loading}
                    required
                    style={{
                      width: "100%",
                      padding: "0.75rem 1rem",
                      borderRadius: "0.5rem",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                      background: "rgba(255, 255, 255, 0.08)",
                      color: "white",
                      marginBottom: "0.75rem",
                    }}
                  />
                  <button type="submit" disabled={loading} className="google-signin-btn" style={{ marginBottom: 0 }}>
                    <div className="btn-background"></div>
                    <div className="btn-content">{loading ? "Creating account..." : "Create account"}</div>
                  </button>
                </form>
              )}
              {error && (
                <p style={{ color: "#fca5a5", fontSize: "0.875rem", marginBottom: "1rem", textAlign: "center" }}>
                  {error}
                </p>
              )}
              {status && (
                <p style={{ color: "#86efac", fontSize: "0.875rem", marginBottom: "1rem", textAlign: "center" }}>
                  {status}
                </p>
              )}
              {done && (
                <div style={{ textAlign: "center", marginBottom: "1rem" }}>
                  <button type="button" onClick={handleResend} disabled={loading} className="google-signin-btn" style={{ marginBottom: "0.75rem" }}>
                    <div className="btn-background"></div>
                    <div className="btn-content">{loading ? "Sending..." : "Resend verification email"}</div>
                  </button>
                </div>
              )}
              <div style={{ textAlign: "center" }}>
                <Link to={signInPath} style={{ color: "#e879f9", textDecoration: "none", fontSize: "0.875rem" }}>
                  Back to sign in
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateAccount;
